import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router';
import { AppProviders } from './app/providers';
import { initPwa } from './app/pwa';
import { router } from './app/router';
import { installInputModality } from './lib/inputModality';
import './styles/index.css';

initPwa();
installInputModality();

const root = document.getElementById('root');
if (!root) throw new Error('Не знайдено #root');

createRoot(root).render(
  <StrictMode>
    <AppProviders>
      <RouterProvider router={router} />
    </AppProviders>
  </StrictMode>,
);
